import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import ManagerHeader from './ManagerHeader'
import { useNavigate } from 'react-router-dom'
import { FaEdit, FaRedo, FaSearch, FaTrashAlt, FaUserPlus } from 'react-icons/fa'

export default function AllBedList() {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()

  const [beds, setBeds] = useState([])
  const [filteredBeds, setFilteredBeds] = useState([])

  const [selectedType, setSelectedType] = useState('All')
  const [selectedStatus, setSelectedStatus] = useState('All')

  const [loading, setLoading] = useState(false)

  const fetchBeds = async() => {
    try{
      setLoading(true)

      const res = await axios.get(`${config.baseurl}get_all_beds/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('All Beds:', beds)


      if(res.status === 200){
        const data = res.data.data || []

        setBeds(data)
        setFilteredBeds(data)
      }else{
        toast.error('Fails to fetch beds')
      }
    }catch(error){
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to fetch telecaller'

      toast.error(message)
    }finally{
      setLoading(false)
    }
  }

  const handleSearch = () => {
    let result = [...beds]

    if(selectedType !== 'All'){
      result = result.filter(bed => bed.bed_type === selectedType)
    }

    if(selectedStatus !== 'All'){
      result = result.filter(bed => bed.status === selectedStatus)
    }

    setFilteredBeds(result)
  }

  const handleReset = () => {

    setSelectedType('All')
    setSelectedStatus('All')

    setFilteredBeds(beds)
  }

  useEffect(() => {
    fetchBeds()
  },[token])
  console.log('All Beds:', beds)

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <ManagerHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL Beds
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all beds.
        </p>
      </div>

<div className="max-w-7xl mx-auto px-4 sm:px-6 pb-10">
    <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-4 sm:p-5 mb-6">

        <div className="grid grid-cols-4 5xl:grid-cols-1 gap-4 items-end">

            {/* Bed Type */}
            <div>
                <label className="block text-sm font-medium mb-2 text-slate-700">
                    Bed Type
                </label>

                <select
                    className="w-full border border-slate-300 rounded-md px-4 py-2.5 bg-white outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                >
                    <option value="All">All</option>
                    <option value="Child">Child</option>
                    <option value="Aged Person">Aged Person</option>
                </select>
            </div>

            {/* Status */}
            <div>
                <label className="block text-sm font-medium mb-2 text-slate-700">
                    Status
                </label>

                <select
                    className="w-full border border-slate-300 rounded-md px-4 py-2.5 bg-white outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                >
                    <option value="All">All</option>
                    <option value="Allocated">Allocated</option>
                    <option value="Not Allocated">Not Allocated</option>
                </select>
            </div>

            {/* Search */}
            <div className="flex items-end">
                <button
                    type="button"
                    onClick={handleSearch}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-slate-300 rounded-md shadow-sm bg-blue-500 text-white hover:bg-blue-600 transition"
                >
                    <FaSearch />
                    <span>Search</span>
                </button>
            </div>

            {/* Reset */}
            <div className="flex items-end">
                <button
                    type="button"
                    onClick={handleReset}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-slate-300 rounded-md shadow-sm bg-slate-300 text-slate-700 hover:bg-slate-400 transition"
                >
                    <FaRedo />
                    <span>Reset</span>
                </button>
            </div>

        </div>
    </div>
</div>

      <div className='max-w-7xl mx-auto px-6 pb-10'>
        <div className='bg-white rounded-lg shadow-sm border overflow-hidden'>
          <div className='overflow-x-auto'>
          <table className='w-full table-auto'>
            <thead>
              <tr className='text-center border-b border-slate-300'>
                <th className='px-3 py-2 whitespace-nowrap'>No</th>
                <th className='px-3 py-2 whitespace-nowrap'>Bed Number</th>
                <th className='px-3 py-2 whitespace-nowrap'>Description</th>
                <th className='px-3 py-2 whitespace-nowrap'>Bed Type</th>
                <th className='px-3 py-2 whitespace-nowrap'>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredBeds.length > 0 ? (
                filteredBeds.map((item, index) => (
                  <tr
                    key={item.id}
                    className='justify-center text-center border-b border-b-slate-300 cursor-pointer'
                  >
                    <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                    <td className='px-3 py-2 whitespace-nowrap'>{item.bed_no}</td>
                    <td className='px-3 py-2 whitespace-nowrap'>{item.description}</td>
                    <td className='px-3 py-2 whitespace-nowrap'>
                      <input
                        className="px-3 py-2 text-center"
                        value={item.bed_type || ''}
                        onChange={(e) => {
                          const updatedBeds = beds.map((bed) => bed.id === item.id ? {...bed, bed_type:e.target.value} : bed)
                          setBeds(updatedBeds)
                        }}
                      />
                    </td>
                    <td className='px-3 py-2 whitespace-nowrap'>
                      <input
                        className="px-3 py-2 text-center"
                        value={item.status || ''}
                        onChange={(e) => {
                          const updatedBeds = beds.map((bed) => bed.id === item.id ? {...bed, status:e.target.value} : bed)
                          setBeds(updatedBeds)
                        }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={6}
                    className='text-center py-6'
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  )
}
